function getRandomInt(max) {
	return Math.floor(Math.random() * max);
}

const GetStatus = (item, start, end) => {
	const now = new Date();
	if (now < start) {
		return "SCHEDULE";
	}

	if (start < now && now < end) {
		return "ONGOING";
	}
	if (end < now) {
		return "CLOSED";
	}
};

export { getRandomInt, GetStatus };
